import styled, { css } from 'styled-components';
export const Container = styled.div `
  display: inline-block;
`;
const underlineStyles = css `
  cursor: default;
  text-decoration-line: underline;
  text-decoration-style: dotted;
  text-decoration-skip-ink: auto;
  text-decoration-thickness: 10%; /* 1.6px */
  text-underline-offset: 25%; /* 4px */
`;
export const MainValue = styled.div `
  color: var(--text-primary);
  /* body/md/medium */
  font-family: var(--font-family-body);
  font-size: var(--font-size-400);
  font-style: normal;
  font-weight: var(--font-weight-regular);
  line-height: var(--font-line-height-400); /* 150% */
  letter-spacing: var(--font-letter-spacing-normal);

  ${({ bold }) => bold &&
    css `
      font-weight: var(--font-weight-medium);
    `}

  ${({ underline }) => underline &&
    css `
      ${underlineStyles};
    `}
`;
export const CompareValue = styled.div `
  color: var(--text-secondary);

  /* body/sm/regular */
  font-family: var(--font-family-body);
  font-size: var(--font-size-300);
  font-style: normal;
  font-weight: var(--font-weight-regular);
  line-height: var(--font-line-height-300); /* 142.857% */
  letter-spacing: var(--font-letter-spacing-loose);

  ${({ underline }) => underline &&
    css `
      ${underlineStyles};
    `}
`;
export const ChangeIndicator = styled.div `
  color: var(--text-secondary);
  /* body/sm/regular */
  font-family: var(--font-family-body);
  font-size: var(--font-size-300);
  font-style: normal;
  font-weight: var(--font-weight-regular);
  line-height: var(--font-line-height-300); /* 142.857% */
  letter-spacing: var(--font-letter-spacing-loose);
  display: flex;
  justify-content: flex-start;

  ${({ align }) => align === 'right' &&
    css `
      justify-content: flex-end;
    `}
`;
